import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectGoogleCalendarManagerDomain = (state) =>
	state.get('googleCalendarManager', initialState);

const makeSelectCalendars = () =>
	createSelector(selectGoogleCalendarManagerDomain, (substate) =>
		substate.get('calendars'),
	);

const makeSelectLoading = () =>
	createSelector(selectGoogleCalendarManagerDomain, (substate) =>
		substate.get('loading'),
	);

const makeSelectError = () =>
	createSelector(selectGoogleCalendarManagerDomain, (substate) =>
		substate.get('error'),
	);

const makeSelectDeleting = () =>
	createSelector(selectGoogleCalendarManagerDomain, (substate) =>
		substate.get('deleting'),
	);

export {
	selectGoogleCalendarManagerDomain,
	makeSelectCalendars,
	makeSelectLoading,
	makeSelectError,
	makeSelectDeleting,
};
